import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GUIDHelpers } from '../../shared/utilities/developHelpers';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ImageInfo, SingleOrDoubleClick, EditImageFile, ImagesToTree } from './imageHelper';
import { DomSanitizer } from '@angular/platform-browser';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css']
})
export class ImageViewerComponent implements OnInit, OnChanges {
  help = new GUIDHelpers();
  rootId = this.help.newGUID();
  coworkerId = this.help.newGUID();
  adminId = this.help.newGUID();
  modalId: string; // Unique id for component modal
  selectionMode: boolean = false;
  selectionFiltered: boolean = false;
  selection: Array<string> = [];
  currentSelect: string;
  currentImageArray: Array<ImageInfo>;
  currentImageIndex: number;
  currentPdf;
  user = { id: localStorage.getItem('bearer'), isAdmin: false, hasOS: JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Ordrestyring') != null }
  tools = new ImageViewerManipulators();
  timer;
  showOptions: boolean = false;
  showFileDeletion: boolean = false;

  @Input() images: Array<ImageInfo>;
  @Output() imagesChange = new EventEmitter<Array<ImageInfo>>();

  @Input() files: any;
  @Output() filesChange = new EventEmitter<any>();
  @Input() restrictedFiles = [];
  @Input('options') inputOptions: any;
  options = new ImageViewerOptions();

  @Input() type: ImageViewerType;
  @Output() delete = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Output('selection') selectedImages = new EventEmitter<Array<string>>()
  @HostListener('document:click') documentClick() { this.showContext = false; this.showOSContext = false; }
  root;
  click;
  tree;
  folders;
  pathToId: Object = {};
  idToPath: Object = {};
  selectedFolder: string = 'folder.customer';
  dragging;
  addFileHover: boolean;
  hasOrdrestyring = false;
  OSdocuments = [];
  OSqualityAssurances = [];
  importedOSFiles = [];
  gettingOSFiles = false;
  gottenOSFiles = false;
  fileFolders = [ ];
  fileImages = [];
  pdfZoom = 1;
  fileIdToExt = {
  'jpg': { id: 'C4AE7891-6179-40FE-9F53-FB52F0889ABC', mime: 'image/jpeg' },
  'jpeg': { id: 'C4AE7891-6179-40FE-9F53-FB52F0889ABC', mime: 'image/jpeg' },
  'png': { id: 'C1B89127-CF88-4477-BA7B-6040B0B8B5A6', mime: 'image/png' },
  'pdf': { id: '71E32E6A-FF53-4CE2-9704-1C9FC94212F1', mime: 'application/pdf' },
  'xlsx': { id: '070CD1BE-60C1-479F-A38C-AAB603DD8D11', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  'xls': { id: '69E80CCE-7FF3-42C1-92CE-75137E557F94', mime: 'application/excel' },
  'heic': { id: 'D901D49C-A6EA-476F-A126-41C0317C0780', mime: 'image/heic' },
  'pptx': { id: '7EE21B48-DAE1-48C6-929F-E1BFEF4AB828', mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' }
  }

  fileExtToId = {
    'image/jpeg': 'C4AE7891-6179-40FE-9F53-FB52F0889ABC',
    'image/png': 'C1B89127-CF88-4477-BA7B-6040B0B8B5A6',
    'application/pdf': '71E32E6A-FF53-4CE2-9704-1C9FC94212F1',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '71E32E6A-FF53-4CE2-9704-1C9FC94212F1',
    'application/excel': '69E80CCE-7FF3-42C1-92CE-75137E557F94',
    'image/heic': 'D901D49C-A6EA-476F-A126-41C0317C0780',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
  }
  showContext = false;
  showOSContext = false;
  context = {
    top:'100px',
    left:'200px',
    item:null
  }
  deletionFolders = [];
  deletionFiles = [];
  showFolderDelete = false;
  mainFolderCounts;
  isPartnerFolder = [];
  constructor(private http: HttpClient, private sanitize: DomSanitizer, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.modalId = this.help.newGUID(); // Making the component unique regardless of placement and user input
  }

  ngOnChanges(c: SimpleChanges) {
    // If user adds options. Options are replaced with user input if option exists
    if (!!c.inputOptions && c.inputOptions.currentValue != null && c.inputOptions.currentValue != c.inputOptions.previousValue) {
      for (let x of Object.keys(c.inputOptions.currentValue)) {
        if (this.options[x] != null) {
          this.options[x] = c.inputOptions.currentValue[x];
        }
        if (x == 'selectable' && c.inputOptions.currentValue[x] == true) {
          this.selectionMode = true;
        }
        //console.log(this.inputOptions, this.options, c.inputOptions.currentValue[x])
      }
    }
    if (!!c.images && !!c.images.currentValue) {
      c.images.currentValue = Array.isArray(c.images.currentValue) ? c.images.currentValue : [c.images.currentValue];
      if (this.options.showTree) {
        //console.log(c.images.currentValue)
        //this.tree = new ImagesToTree();
        if(!this.files){
          //console.log('Found images, no files. Creating folders')
          this.createFolders();
        }
        // loop through all images and create and id for each folder
        // link images that belong to that folder
        // when a file or files are moved to new folder, all images should be updated with the new folder path
        // when a folder is renamed, all images in subcategories should have their paths renamed accordingly
      } else if (this.options.autoOpen && !!c.images.currentValue && c.images.currentValue.length > 0) {
        this.currentImageArray = c.images.currentValue;
        this.currentImageIndex = 0;
        this.openModal(c.images.currentValue[0].fileId, false);
      } else if (this.options.autoOpen && !!c.images.currentValue) {
        this.currentImageArray = c.images.currentValue;
        this.currentImageIndex = 0;
        this.openModal(c.images.currentValue[0].fileId, false);
      } else {
        this.currentImageArray = c.images.currentValue.sort((a, b) => { return a.originalName?.toLowerCase() > b.originalName?.toLowerCase() ? 1 : - 1 });
      }
      // images are input
      // if mode is tree view then create folder structure from file paths and set current view folder to be root folder
      // if not tree view then put images in current view folder
      
    }
    if (!!c.files && !!c.files.currentValue) {
      //console.log('Images as files, converting tree')
      this.convertOldTreeToNewTree();
    }
  }

  fileClick(id: string) {
    if (this.selectionMode) {
      if (!this.click) {
        this.click = { id: id, time: new Date().getTime() };
         this.timer = setTimeout(() => {
           this.selection = this.selection.includes(this.click.id) ? this.selection.filter(x => x != this.click.id) : this.selection.concat([this.click.id]);
           this.selectedImages.emit(this.selection);
            this.click = null;
           this.timer = null;
           if (this.selectionFiltered) {
            this.filterSelection(true);
           }
          }, 200);
      }
      else {
        // did user click the same file or just clicked another file within the time?
        if (this.click.id == id) {
          clearTimeout(this.timer)
          this.click = null;
          this.openModal(id, false);
        }
        else {
          this.selection = this.selection.includes(this.click.id) ? this.selection.filter(x => x != this.click.id) : this.selection.concat([this.click.id]);
          this.selectedImages.emit(this.selection)
          if (this.selectionFiltered) {
            this.filterSelection(true);
          }
          this.click = { id: id, time: new Date().getTime() };
          this.timer = setTimeout(() => {
            this.selection = this.selection.includes(this.click.id) ? this.selection.filter(x => x != this.click.id) : this.selection.concat([this.click.id]);
            this.selectedImages.emit(this.selection)
            this.click = null;
            this.timer = null;
            if (this.selectionFiltered) {
              this.filterSelection(true);
            }
          }, 200);
        }
      }
      // when selectionMode, a timer will be set to see if user clicks eller double clicks
      // if user clicks once and timer ends, the id will be added or subtracted from the selection
      // if user clicks once more and timer has not ended, the timer will be removed and modal will be opened.
    }
    else { this.openModal(id, false); }
  }

  contextMenu(item, event) {
    event.preventDefault();
    if(!this.options.hideOptions){
      this.selection = [item.fileId];
      this.showContext = true;
      this.context.top = (event.clientY - 20).toString() + 'px';
      this.context.left = (event.clientX - 200).toString() + 'px';
      this.context.item = item;
    }
  }

  contextOSmenu(item, event){
    this.selection = [item.fileName];
    event.preventDefault();
    this.showOSContext = true;
    this.context.top = (event.clientY - 20).toString() + 'px';
    this.context.left = (event.clientX - 200).toString() + 'px';
    this.context.item = item;
  }

  async openModal(id, isOpen) {
    this.pdfZoom = 1;
    this.currentImageIndex = await this.currentImageArray.map(x => { return x.fileId }).indexOf(id);
    if (this.currentImageArray[this.currentImageIndex].extension == '.pdf') {
      this.currentPdf = fetch(this.getURL(this.currentImageArray[this.currentImageIndex].fileId)).then(res => res.blob()).then(blob => {
        this.currentPdf = URL.createObjectURL(blob)
      })
    }
    if (!isOpen) {
      document.getElementById('imageView' + this.modalId + 'Activator').click();
    }
  }

  selectSwitch() {
    if (this.selectionMode) {
      this.selectionMode = false;
      this.filterSelection(false);
      this.selection = [];
    }
    else { this.selectionMode = true }
  }

  filterSelection(x: boolean) {
    // if true then add filtered selection to currentImageArray
    if (x) {
      this.currentImageArray = this.images.filter(x => this.selection.includes(x.fileId)).sort((a, b) => { return a.originalName.toLowerCase() > b.originalName.toLowerCase() ? 1 : - 1 });
      if (this.currentImageArray.length > 0) { this.selectionFiltered = true }
      else { this.filterSelection(false) }
    }
    else {
      // if not filtered by selection, do normal image filter
      this.filterImages();
      this.selectionFiltered = false;
    }
}

  getURL(id) {
    return api.jubloApi + 'api/shared/attachments/' + id + '?userId=' + localStorage.getItem('bearer');
  }

  //FILE OPERATIONS

  async editAccessOnSelected(accessId: string) {
    // filter selected files that have fileAccess id that is different from the one chosen
    let files = await this.images.filter(x => this.selection.includes(x.fileId) && x.fileAccess != accessId);
    this.editFiles(files.map(x => {
      return {
        fileId: x.fileId,
        path: x.path,
        fileAccessId: accessId
      }
    }))
    for (let x of files) {
      x.fileAccess = accessId
    }
  }

  async editPathOnSelected(path: string) {
    let files = await this.images.filter(x => this.selection.includes(x.fileId));
    this.editFiles(files.map(x => {
      return {
        fileId: x.fileId,
        path: path,
        fileAccessId: x.fileAccess
      }
    }))
    for (let x of files) {
      x.path = path
    }
    this.selection = [];
    this.filterImages();
  }
  async editParentOnSelected(){

  }
  //API CALLS
  // copy paramater is a bool, if true it copies (ctrl + c) and if false it removes (ctrl + x)
  // It is only copying when dragging file to partner folder and in the other folders it moves completely
  attachFileToFolder(caseId,fileId, folderId,copy){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/shared/attachments/CopyFileToCase',{
      caseId: caseId,
      fileId: fileId,
      folderId: folderId,
      copy: copy
    },{headers}).subscribe(
      (data)=>{
        this.fileImages.find(x => x.fileId == fileId).parentId = folderId;
        this.filterImages();
        this.selection = [];
        this.reloader();
      }
    )
  }

  editFiles(f: Array<EditImageFile>) {
    console.log('editing files')
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    for (let x of f) {
      this.http.put(api.jubloApi + 'api/shared/Attachments/EditFilePath', x, { headers }).subscribe(
        (data) => {},
        (response) => { console.log('Error', response)},
        () => {}
      )
    }
  }

  deleteFiles() {
    // after file deletion, the files must be removed from images and emitted
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    if (this.type.type == 'case') {
      this.http.post(api.jubloApi + 'api/Website/Case/RemoveFileFromCase/' + this.type.id, this.selection, { headers }).subscribe(
        (data) => { },
        (response) => { console.log('Can not delete files', response) },
        () => {
          this.images = this.images.filter(x => !this.selection.includes(x.fileId));
          this.fileImages = this.fileImages.filter(x => !this.selection.includes(x.fileId));
          this.selection = [];
          this.filterImages();
        }
      )
    }
    else {
      for (let x of this.selection) {
        switch (this.type.type) {
          case ('activity'): {
            this.http.delete(api.jubloApi + 'api/Activity/DeleteFileFromActivity/' + this.type.id + '/' + x, {headers}).subscribe(
              (data) => { },
              (response) => { console.log('Can not delete files', response) },
              () => {
                this.images = this.images.filter(x => !this.selection.includes(x.fileId));
                this.selection = [];
                this.filterImages();
              }
            )
              ;break
          }
          case ('property'): {
            this.http.delete(api.jubloApi + 'api/PropertyLease/DeleteFileFromProperty/' + this.type.id + '/' + x, {headers}).subscribe(
              (data) => { },
              (response) => { console.log('Can not delete files', response) },
              () => {
                this.images = this.images.filter(x => !this.selection.includes(x.fileId));
                this.selection = [];
                this.filterImages();
              }
            );
            break
          }
          case ('package') : {
            this.delete.emit(x);
            this.images = this.images.filter(y => y.fileId != x)
            break
          }
        }
      }
    }
  }

  getOSFiles() {
    console.log('Getting OS files')
    if (this.OSdocuments && this.OSdocuments.length == 0) {
      this.importedOSFiles = this.fileImages.map(x => x.originalName);
      this.gottenOSFiles = false;
      this.gettingOSFiles = true;
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.http.get(api.jubloApi + 'api/Website/Case/GetOsDocuments/' + this.type.id, { headers }).subscribe(
        (data: any) => {
          this.gottenOSFiles = true;
          if (!!data) {
            this.prepareOSFiles(data.documents.sort( (a,b)=> a.createdAt > b.createdAt ? 1 : -1));
          }
        },
        (res) => {
          console.log(res)
          this.gottenOSFiles = false;
          this.gettingOSFiles = false;
          this.getOSQualityDocuments();
        },
        () => {
          this.getOSQualityDocuments();
        }
      )
    } else {
      this.gettingOSFiles = false;
    }
  }

  getOSQualityDocuments() {
    console.log('Getting OS Quality Docs')
    this.gettingOSFiles = false;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Website/Case/GetKvalitetsSikring/' + this.type.id, { headers }).subscribe(
      (data: Array<any>) => {
        if (!!data) {
          this.OSqualityAssurances = data.map(x => { 
            return { ...x, selected: false, baseString: x.base64, fileType: '71E32E6A-FF53-4CE2-9704-1C9FC94212F1', fileName: x.fileName + '.pdf' } 
          });
        }
      },
      (res) => {
        console.log(res);
      },
      () => {
      }
    )
  }

  async prepareOSFiles(data: Array<any>) {
    if (!!data) {
      this.OSdocuments = [];
      for (var i = 0; i < data.length; i++) {
        let ext = data[i].filename.split('.').reverse()[0];
        let end = this.fileIdToExt[ext];
        if(!end) {continue}
        let base = await this.sanitize.bypassSecurityTrustResourceUrl('data:' + end.mime + ';base64, ' + data[i].fileContent);
        this.OSdocuments.push(
          {
            fileName: data[i].filename,
            extension: ext,
            fileType: end.id,
            base64: base,
            baseString: data[i].fileContent,
            selected: false
          }
        )
      }
    }
    this.gettingOSFiles = false;
  }
  osFileSelected() {
    return !!this.OSdocuments.concat(this.OSqualityAssurances).find(x => !!x.selected);
  }

  addFileToOs(file) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Website/Case/AddFileFromOS', {
      caseId: this.type.id,
      fileName: file.fileName,
      fileTypeId: file.fileType,
      base64: file.baseString
    }, { headers }).subscribe(
      (data) => {
        this.fileImages.push({ ...data, parentId: this.root });
        console.log(this.fileImages)
      },
      (res) => {
        console.log(res);
      },
      () => {
        // if it is the last file, ask files to be reloaded from case
        console.log('done');
      }
    )
  }

  async addOSFiles() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    let files : Array<any> = await this.OSqualityAssurances.filter(x => x.selected).concat(this.OSdocuments.filter(x => x.selected));
    for (var i = 0; i < files.length; i++) {
      this.http.post(api.jubloApi + 'api/Website/Case/AddFileFromOS', {
        caseId: this.type.id,
        fileName: files[i].fileName,
        fileTypeId: files[i].fileType,
        base64: files[i].baseString
      }, { headers }).subscribe(
        (data) => {
          this.importedOSFiles = this.importedOSFiles.concat(files.map(x => x.fileName));
          this.fileImages.push({...data, parentId:this.root});
          // if data is returned, then attach those files to the correct folder
        },
        (response) => {},
        () => {
          if (i == files.length) {
            this.reloader();
          }
          // if it is the last file, ask files to be reloaded from case
        }
      )

    }
  }

  async addOSFile(fileName,fileType,baseString){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Case/AddFileFromOS', {
        caseId: this.type.id,
        fileName: fileName,
        fileTypeId: fileType,
        base64: baseString
      }, { headers })
  }

  trackFileId(index, user){
    return user.fileId;
  }

  trackOriginalName(index, user){
    return user.originalName;
  }

  trackFileName(index, user){
    return user.fileName;
  }

  sendFilesToOS() {
    this.showOptions = false;
    console.log(this.selection);
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.post(api.jubloApi + 'api/Website/Case/FilesToOS/' + this.type.id, this.selection, { headers }).subscribe(
      (data) => { 
        console.log(data);
      },
      (res) => { console.log(res); },
      () => { this.selection = [] }
    )
  }

  filesToOS(){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Case/FilesToOS/' + this.type.id, this.selection, { headers })
  }

  isOSFileImported(file){
    return this.importedOSFiles.includes(file.fileName)
  }

  async createFolders() {
    let uniqueFilePaths = await Array.from(new Set(this.images.map(x => { return x.path })));
    this.pathToId[''] = this.rootId;
    this.folders = [
      { name: 'root', id: this.rootId, parentId: null, folderPath: '', showChildren: true, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: false, draggable: false }
    ];
    this.folders = this.folders.concat(this.fileFolders);
    let count = 0;
    if (uniqueFilePaths.length == 0) { this.treeFromFolders() } // if no paths, then continue
    for (let x of uniqueFilePaths) {
      if (x != null && x != '') {
        let path = x.split('/');
        for (var i = 0; i < path.length; i++) {
          if (!this.pathToId[path.slice(0, i + 1).join('/')]) { this.pathToId[path.slice(0, i + 1).join('/')] = this.help.newGUID() }
          this.folders.push(
            {
              name: path[i],
              id: this.pathToId[path.slice(0, i + 1).join('/')],
              parentId: i > 0 ? this.pathToId[path.slice(0, i).join('/')] : this.rootId,
              folderPath: path.slice(0, i + 1).join('/'),
              showChildren: false,
              right: null,
              editing: false,
              draggable: true
            }
          );
          if (i == path.length - 1) {
            count += 1;
            if (count == uniqueFilePaths.length) { this.treeFromFolders() } // if all paths are done, then continue
          }
        } // end of inner for loop
      }
      else {
        count += 1;
        if (count == uniqueFilePaths.length) { this.treeFromFolders() };// if all paths are done, then continue
      }
    } // end of outer for loop
  }

  treeFromFolders() {
    // do we need a idToPath?
    let treeFolders = !!this.files ? this.fileFolders : this.folders;
    // console.log(this.files)
    // console.log(this.fileFolders)
    // console.log(this.folders)
    if( this.files && this.fileFolders.filter(x => ['folder.customer','folder.technician','folder.admin'].includes(x.name)).length < 3 ){
      // console.log('All standard folder still not found, but what happens if you are not administrator?')
      setTimeout(()=>{this.treeFromFolders()},1000)
    }
    // for (let x of Object.keys(this.pathToId)) {
    //   this.idToPath[this.pathToId[x]] = x;
    // }
    let root;
    var tree: any = [], mappedArr = {}, arrElem, mappedElem;
    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = treeFolders.length; i < len; i++) {
      arrElem = treeFolders[i];
      mappedArr[arrElem.id] = arrElem;
      if(arrElem.name == 'folder.customer'){ 
        root = arrElem.id;
       }
      mappedArr[arrElem.id]['children'] = [];
    }
    for (var id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.parentId) {
          let thisFolder = mappedArr[mappedElem['parentId']];
          if(!!thisFolder){
            mappedArr[mappedElem['parentId']]['children'].push(mappedElem);
            mappedArr[mappedElem['parentId']]['children'] = mappedArr[mappedElem['parentId']]['children'].sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 });
          }
          else {
            mappedElem.parentId = root;
            mappedArr[root]['children'].push(mappedElem);
            mappedArr[mappedElem['parentId']]['children'] = mappedArr[mappedElem['parentId']]['children'].sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 });
          }
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          mappedElem['children'] = mappedElem['children'].sort((a, b) => {return  a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 });
          tree.push(mappedElem);
        }
      }
    }
    this.tree = this.treeSort(tree);
    this.filterImages();
  }

  treeSort(tree){
    return tree.sort((a,b)=> {
      if(a.name == 'folder.customer' || b.name == 'folder.customer') return a.name == 'folder.customer' ? -1 : 1;
      if(a.name == 'folder.technician' || b.name == 'folder.technician') return a.name == 'folder.technician' ? -1 : 1;
      if(a.name == 'folder.admin' || b.name == 'folder.admin') return a.name == 'folder.admin' ? -1 : 1;
      if(a.name == 'Ordrestyring' || b.name == 'Ordrestyring') a.name == 'Ordrestyring' ? 1 : -1;
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
    })
  }

  async addFolder() {
   let parent = this.files ? await this.fileFolders.find(x => x.id == this.selectedFolder) : await this.folders.find(x => x.id == this.selectedFolder);
   let newId;
   if(this.files){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
     this.http.post(api.jubloApi + 'api/shared/Attachments/FolderToCase', {
      caseId: this.type.id,
      folderId: null,
      parentFolder: this.selectedFolder,
      folderName: 'new',
      fileAccessId: null
    }, {headers}).subscribe(
      (data:any)=> { typeof(data) == 'string' ? newId = data : newId = data.success; console.log(data) },
      ()=>{},
      ()=>{
        this.fileFolders.push({ name: 'new', id: newId, parentId: this.selectedFolder, folderPath: null, showChildren: false, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: true });
        this.treeFromFolders();
      }
     )
   }
   else {
    newId = this.help.newGUID();
    let path = parent.folderPath == '' ? 'new' : parent.folderPath + '/' + 'new';
    this.idToPath[newId] = path;
    this.pathToId[path] = newId;
    this.folders.push({ name: 'new', id: newId, parentId: this.selectedFolder, folderPath: path, showChildren: false, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: true });
    this.treeFromFolders();
   }
   
  }

  filterImages() {
    if(!!this.files){
      let filtering = this.options.showTree ? this.fileImages.filter(x => x.parentId == this.selectedFolder) : this.fileImages;
      this.currentImageArray = filtering.sort((a, b) => { return a.originalName.toLowerCase() > b.originalName.toLowerCase() ? 1 : - 1 });
    }
    else {
      let path = this.selectedFolder != null ? this.folders.find(x => x.id == this.selectedFolder).folderPath : null;
      if (this.options.showTree && !this.options.hideTree) {
        if (path == null || path == '') {
          this.currentImageArray = this.images.filter(x => x.path == null || x.path == '').sort((a, b) => { return a.originalName.toLowerCase() > b.originalName.toLowerCase() ? 1 : - 1 });
        }
        else {
          this.currentImageArray = this.images.filter(x => x.path == path).sort((a, b) => { return a.originalName.toLowerCase() > b.originalName.toLowerCase() ? 1 : - 1 });
        }
      }
      else { this.currentImageArray = this.images.sort((a, b) => { return a.originalName.toLowerCase() > b.originalName.toLowerCase() ? 1 : - 1 }); } // if no tree
    }
}

  async fromBranch(e) {
    switch (e.type) {
      case ('selectFolder'): {
        this.selectedFolder = e.folder.id;
        this.filterImages();
        if(this.selectedFolder == 'OS'){ this.selectionMode = true;this.getOSFiles() }
        else this.selectionMode = false;
        ;break
      }
      case ('dropped'): {
        if (this.dragging != null && this.dragging.type == 'file') {
          // a file is dragged and can either be dragged from OS or not.
          // if a file is not dragged from OS, it can either be dragged from
          // this.selection = await Array.from(new Set(this.selection.concat([this.dragging.id])));
          this.selection = [this.dragging.id];
          if (this.files) {
            let f = this.files.files.filter(x => x.folderId == e.id).map(y => y.files);
            //This checks if the file is already at the folder before
            if (e.id != 'OS' && this.dragging.from == 'Jublo' && f[0].filter(x => x.fileId == this.selection[0]).length > 0) {
            }
            //This checks if the folder is the partner folder, then it copies the file instead
            else if (this.isPartnerFolder.includes(e.id) && this.dragging.from == 'Jublo' || e.id != 'OS' && !this.isPartnerFolder.includes(e.id) && this.isPartnerFolder.includes(this.dragging.id)) {
              this.selection.forEach(x => this.attachFileToFolder(this.type.id, x, e.id, true));             
            }
            //This moves the file over to another folder
            else if (e.id != 'OS' && (this.dragging.from == 'Jublo')) {
              this.selection.forEach(x => this.attachFileToFolder(this.type.id, x, e.id, false));
            }
            else if(e.id != 'OS' && this.dragging.from == 'OS'){
              // need a check to see if multiple files were selected
              let selection = this.OSdocuments.concat(this.OSqualityAssurances).filter(x => x.selected);
              if(!!selection && selection.length > 0){
                this.addOSFiles()
              }
              else {
                let files = this.selection.map(x => {
                  if(!!this.OSdocuments.find(y => y.fileName == x)){ return this.OSdocuments.find(y => y.fileName == x)}
                  return this.OSqualityAssurances.find(y => y.fileName == x)
                })
                for(let x of files){
                  (await this.addOSFile(x.fileName,x.fileType,x.baseString)).subscribe(
                    (data:any)=> { 
                      this.importedOSFiles = this.importedOSFiles.concat(files.map(x => x.fileName));
                      this.attachFileToFolder(this.type.id,data.fileId,e.id, false);
                      this.fileImages.push({ ...data, parentId: e.id });
                    }
                  )
                }
              }
            }
            else if(e.id == 'OS' && this.dragging.from == 'Jublo'){
              this.filesToOS().subscribe(
                (data)=>{ 
                  // expect no data
                 }
                )
            }
            else {
              let files = this.selection.map(x => {
                if(!!this.OSdocuments.find(y => y.fileName == x)){ return this.OSdocuments.find(y => y.fileName == x)}
                return this.OSqualityAssurances.find(y => y.fileName == x)
              })
              // add file from OS (expect fileId in return)
              // remap that file to merge with other images (with parent Id from the dropped folder e.id)
              // attach that file to Folder
              // add file to other images
            }
          }
          else { 
            let p = e.object.folderPath
            let path = p != null && p != '' ? p : null;
            this.editPathOnSelected(path) }
        }
        else if (this.dragging != null && this.dragging.type == 'folder') {
          console.log('movedFolder',e)
          this.moveFolder(e.object)
        }
        ;break
      }
      case ('draggingFolder'): {
        this.selection = [];
        this.dragging = { type: 'folder', id: e.id };
        break
      }
      case ('folderRename'): {
        let f = !!this.files ? await this.fileFolders.find(x => x.id == e.id) : await this.folders.find(x => x.id == e.id);
        console.log('Renaming '+ f.name.toString() + ' to: ' + e.newName.toString())
        console.log(e)
        f.name = e.newName;
        if(this.files){
          this.renameFolder(e.id,e.newName);
        }
        else {
          let originalFolderPath = f.folderPath;
          let folderArray = f.folderPath.split('/').reverse();
          folderArray[0] = f.name;
          let newFolderPath = folderArray.reverse().join('/');
          this.idToPath[e.id] = newFolderPath;
          this.pathToId[newFolderPath] = e.id;
          this.folderChanges(originalFolderPath, newFolderPath);
          // Renaming a folder afffects all sub folders and all files in the folder or its sub folders
          f.folderPath = this.changeEndPathPoint(f.folderPath, f.name);
          // all files and folders that start with old path, will have the path replaced by the new path
          this.treeFromFolders();
        }
        ; break
      }
      case('deleteFolder'):{
        if(e.item.children.length > 0 || !!this.fileImages.find(x => x.parentId == e.id )){
          this.getDeleteFolders(e.id);
        }
        else {
          this.deleteFolder(e.id);
        }
        break
      }
      case('addNewSubFolder'):{
        console.log(this.selectedFolder,'new SubFolder', e);
        this.addFolder();
        break

      }
    }
  }

  getDeleteFolders(id){
    let folder = this.fileFolders.find(x => x.id == id);
    this.deletionFolders.push(folder.id);
    this.deletionFiles = this.deletionFiles.concat(this.fileImages.filter(x => x.parentId == id))
    if(folder.children.length > 0){
      folder.children.forEach(x => this.getDeleteFolders(x.id))
    }
    this.showFolderDelete = true;
  }

  renameFolder(id, newName){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.patch(api.jubloApi + 'api/shared/Attachments/RenameFolder',{
      folderId:id,
      folderName:newName
    }, {headers}).subscribe(
      (data)=>{ console.log('Folder rename', newName) }
    )
  }

  changeEndPathPoint(path, folderName) {
    // folder is not root
    if (path != '' && path != null) {
      let p = path.split('/').reverse();
      p[0] = folderName;
      return p.reverse().join('/')
    }
    else {
      return ''
    }
  }

  imgDrag(fileId,from) {
    this.dragging = { type: 'file', id: fileId, from:from }
  }

  async moveFolder(to: any) {
    if(this.files){
      let a = this.fileFolders.find(x => x.id == this.dragging.id);
      a.parentId = to.id
      console.log(a, to)
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.http.patch(api.jubloApi + 'api/shared/Attachments/UpdateParentFolder', {
        folderId: a.id,
        parentFolderId: to.id
      }, {headers}).subscribe(
        (data)=> { this.treeFromFolders() })
    }
    else {
      // check to see that there is no subfolder in the target folder that shares path with subject folder.
      // a subject folder may have several sub folder with their own paths that needs to be altered.
      // you should not be able to drag the root folder
  
      let t = await this.folders.find(x => x.id == to.id);
      let s = await this.folders.find(x => x.id == this.dragging.id);
      let originalFolderPath = s.folderPath;
      let newFolderPath = t.folderPath != '' ? t.folderPath + '/' + s.name : s.name;
      console.log(originalFolderPath, newFolderPath);
      let subjectStart = t.folderPath + '/' + originalFolderPath.split('/').reverse()[0];
      // find all folders that share the same starting url with the subject
      this.folderChanges(originalFolderPath, newFolderPath);
  
      s.parentId = t.id; // make the target folder the parent of the subject folder
      //this.editPathOnSelected(s.folderPath);
      this.treeFromFolders();
    }
  }

  async moveNewFolder(to:string){
    
  }

  async folderChanges(originalFolderPath, newFolderPath) {
    this.selection = [];
    this.folders.forEach(x => {
      if (x.folderPath.startsWith(originalFolderPath)) { x.folderPath = x.folderPath.replace(originalFolderPath, newFolderPath) }
    });
    await this.images.forEach(x => {
      if (x.path != null && x.path.startsWith(originalFolderPath)) {
        console.log(x, ' starts with original folder path ', newFolderPath)
        x.path = x.path.replace(originalFolderPath, newFolderPath);
        this.selection.push(x.fileId);
      }
    });
    await this.editFiles(await this.images.filter(x => this.selection.includes(x.fileId)).map(x => {
      return {
        fileAccessId: x.fileAccess,
        fileId: x.fileId,
        path: x.path
      }
    }));
    this.selection = [];
  }

  async imgDrop(files) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    let count = 0;
    if (files.length > 0) {
      for (let f of files) {
        //console.log(f, this.type);
        count += 1;
        await this.upload(f).subscribe(
          (res: any) => {
            switch (this.type.type) {
              case ('case'): {
                this.http.post(api.jubloApi + 'api/shared/attachments/AttachFileToCase', { caseId: this.type.id, fileId: res.fileId, folderId: this.selectedFolder }).subscribe(
                  () => { },
                  (response) => { console.log('Error', response) },
                  () => {
                    if (count == files.length) {
                      this.reloader();
                    }
                  }
                )
                ; break;
              }
              case ('property'): {
                this.http.post(api.jubloApi + 'api/PropertyLease/FileToProperty', {
                  propertyId: this.type.id,
                  fileId: res.fileId
                }, { headers }).subscribe(
                  (data) => { console.log(data) },
                  (response) => { console.log('Error!', response) },
                  () => {
                    if (count == files.length) {
                      this.reloader();
                    }
                  }
                )
                ; break;
              }
              case ('activity'): {
                this.http.post(api.jubloApi + 'api/Activity/FileToActivity', {
                  activityId: this.type.id,
                  fileId: res.fileId
                }, { headers }).subscribe(
                  () => { },
                  (response) => { console.log('Error', response) },
                  () => {
                    if (count == files.length) {
                      this.reloader();
                    }
                  }
                )
                ; break;
              }
              default: {
                console.log(res)
                this.images.push(
                  {
                    extension: '.' + res.ext,
                    fileAccess: '4d32156a-20fe-4601-8cc8-0a4711034d6b',
                    fileId: res.fileId,
                    fileTypeId: this.fileExtToId[f.type],
                    originalName: res.fileName,
                    path: null
                  }
                )
                this.imagesChange.emit(this.images);
              }
            }
          },
          (err) => {
            if (err.status == 413) {
              this.toastr.error(f.name,this.translate.instant('Error.FileTooBig'));
            }
          }
        )
      }
    }
  }

  upload(fileToUpload: any) {
    let input = new FormData();
    input.append('file', fileToUpload);
    let fileAccessId = '4D32156A-20FE-4601-8CC8-0A4711034D6B';
    let path = this.options.showTree ? encodeURIComponent(this.idToPath[this.selectedFolder]) : '';
    return this.http.post(api.jubloApi + 'api/shared/attachments/FileWithPath?fileAccessId=' + fileAccessId + '&path=' + path, input);
  }

  reloader() {
    setTimeout(() => {
      this.reload.emit(true);
    }, 500);
  }

  deleteAllFolders(){
    let a = this.files.files.filter(x => ['folder.customer','folder.technician','folder.admin'].includes(x.folderName));
    //console.log(a.length)
    a.forEach(x => this.deleteFolder(x.folderId));
  }

  async convertOldTreeToNewTree() {
    //if folders accidentally gets deleted, you can refresh page to bring back
    this.files.files.forEach(x => { if (!!['folder.customer', 'folder.admin', 'folder.technician'].includes(x.folderName)) { x.parentFolderId = null } });
    // hide admin folder if not admin
    let admin = await !!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'SettingsAccess');
    this.files.files = admin ? this.files.files : this.files.files.filter(x => x.folderName != 'folder.admin');
    // filter PartnerFolder
    this.isPartnerFolder = this.files.files.filter(x => !x.folderName.startsWith('folder.') && !x.parentFolderId).map(x => x.folderId);
    // Check need for new standard folders
    let standardFolders = await this.checkForStandardFolders();
    this.selectedFolder = standardFolders.customer;
    this.root = standardFolders.customer;
    // Map new standard folder here
    if(!this.files.files.find(x => x.folderName == 'folder.customer')){
      this.fileFolders.push({ name: 'folder.customer', id: standardFolders.customer, parentId: null, folderPath: '', showChildren: true, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: false, draggable: false });
      this.fileFolders.push({ name: 'folder.technician', id: standardFolders.user, parentId: null, folderPath: '', showChildren: false, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: false, draggable: false });
      if(!!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'SettingsAccess')){
        this.fileFolders.push({ name: 'folder.admin', id: standardFolders.admin, parentId: null, folderPath: '', showChildren: false, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: false, draggable: false });
      }
    }
    // create a OS folder if module is activated
    if(!!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Ordrestyring') && !!this.type.externalId){
      this.hasOrdrestyring = true;
      this.fileFolders.push({ name: 'Ordrestyring', id: 'OS', parentId: null, folderPath: '', showChildren: false, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: false, draggable: false })
    }
    // await this.findFoldersWithoutParent(standardFolders.customer); // those folders will be placed in the customer folders TODO!!!  --- Set parent ids to folders in dB
    this.fileImages = this.files.filesWithoutFolder.filter(x => !x.path).map(x => { return { ...x, parentId : standardFolders.customer }  }); // files without path get customer folder as parent Id
    let foldersToConvert = {}

    await this.unfoldNewFilesToFolders(this.files.files,null);
    if(standardFolders && this.files && this.files.files){
      this.countFilesInMainFolders(standardFolders,this.files.files)
    }

    let orphanFolders = await (await this.convertOldPathsToNewFolders(this.files.filesWithoutFolder.filter(x => !!x.path && this.fileFolders.find(y => y.name == x.name) == null)));

    if(!!orphanFolders){
      await orphanFolders.forEach(x => this.createNewFolderIdFromImagePath(x).subscribe( val => foldersToConvert[x] = val) );
      if(orphanFolders.length > 0 && this.files.filesWithoutFolder.find(x => !!x.path)){
        let files = this.files.filesWithoutFolder.filter(x => !!x.path);
        files.forEach(x => x.path = null);
        this.editFiles(files.map(x => { return {
          fileId: x.fileId,
          path: null,
          fileAccessId: x.fileAccess
        } }))
       }
      await orphanFolders.forEach(x => this.updateImgFolderParentOnOldFiles(x.name, foldersToConvert[x]));
    }
    this.treeFromFolders();
  }
  
  countFilesInMainFolders(standardFolders,files){
    //console.log(standardFolders, files)
    let customerFolder = files.find(x => x.folderName == 'folder.customer');
    let technicianFolder = files.find(x => x.folderName == 'folder.technician');
    let adminFolder = files.find(x => x.folderName == 'folder.admin');
    let customerCount = customerFolder.files.length + this.findFileCountFromFolderId(standardFolders.customer, files);
    let technicianCount = technicianFolder.files.length + this.findFileCountFromFolderId(standardFolders.user, files);
    let adminCount = !!adminFolder ? adminFolder.files.length + this.findFileCountFromFolderId(standardFolders.admin, files) : 0;
    this.mainFolderCounts = {
      'customer': customerCount,
      'technician': technicianCount,
      'admin' : adminCount
    }
  }

  findFileCountFromFolderId(id, files):number {
    let subCount = 0;
    let childFolders = files.filter(x => x.parentFolderId == id);
    let count = childFolders.reduce((tot, cur)=> tot = tot + cur.files.length  ,0);
    childFolders.map(x => x.folderId).forEach(x => subCount = subCount + this.findFileCountFromFolderId(x, files))
    return count + subCount
    
    }

  async checkForStandardFolders(){
    if(!this.files.files.find(x => ['folder.customer','folder.technician','folder.admin'].includes(x.folderName) )) {
      console.log('creating missing standard folders')
      return await this.createStandardFolders();
    }
    else {
      let admin = await !!this.files.files.find(x =>x.folderName == 'folder.admin' && !x.parentFolderId) ? this.files.files.find(x =>x.folderName == 'folder.admin' && !x.parentFolderId).folderId : ''
      return {
        customer: await this.files.files.find(x =>x.folderName == 'folder.customer' && !x.parentFolderId).folderId,
        user: await this.files.files.find(x =>x.folderName == 'folder.technician' && !x.parentFolderId).folderId,
        admin: admin
      }
    }
  }

  async createStandardFolders(){
    let count = 0;
    let customer; 
    let user;
    let admin;
    await this.createNewFolderIdFromImagePath({id: this.type.id, name:'folder.customer'}).subscribe( 
      val => { customer = val;  count += 1;  }
      );
    await this.createNewFolderIdFromImagePath({id: this.type.id, name:'folder.technician'}).subscribe( val => {user = val; count += 1}  );
    await this.createNewFolderIdFromImagePath({id: this.type.id, name:'folder.admin'}).subscribe( val => {admin = val; count += 1});
    setTimeout(()=>{this.reload.emit(true)},1000)

    return { customer:customer, user:user, admin:admin}
  }

  async findFoldersWithoutParent(customerFolderId) {
    let orphans = this.files.files.filter(x => !['folder.customer','folder.technician','folder.admin'].includes(x.folderName) && !x.parentFolderId);
    orphans.forEach(x => x.parentFolderId = customerFolderId )
  }

  async unfoldNewFilesToFolders(files,id){
    for(let x of files) {
      if(x.folderName){
        let count = x.files.length;
        this.fileFolders.push(
          { name: x.folderName, id: x.folderId, parentId: x.parentFolderId, folderPath: '', showChildren: false, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b', editing: false, draggable: false, count:count }
        )
      }
      else if (!!x.fileId) {
        x['parentId'] = id;
        this.fileImages.push(x);
        if(!!x.path){ this.editFiles([{ fileId: x.fileId, path: null, fileAccessId: x.fileAccess}]) } // remove deprecated path
      }
      if(!!x.files && x.files.length > 0){
        this.unfoldNewFilesToFolders(x.files, x.folderId)
      }
    }
  }

  async countSubFiles(folder, allFiles){
    console.log(folder)
    let files = folder.files.filter(x => !!x.fileId).length;
    for(let x of folder.files.filter(x => !!x.folderId)){
      files += await this.countSubFiles(x, allFiles)
    }
    return files
  }

  async convertOldPathsToNewFolders(files){
    let uniqueFilePaths:Array<string> = await Array.from(new Set(files.map(x => { return x.path })));
    let count = 0;
    let array = [];
    for (let x of uniqueFilePaths) {
        let path = x.split('/');
        for (var i = 0; i < path.length; i++) {
          if (!this.pathToId[path.slice(0, i + 1).join('/')]) { 
            this.pathToId[path.slice(0, i + 1).join('/')] = this.help.newGUID() 
          }
          array.push(
            {
              name: path[i],
              id: this.pathToId[path.slice(0, i + 1).join('/')],
              parentId: i > 0 ? this.pathToId[path.slice(0, i).join('/')] : null,
              folderPath: null,
              showChildren: false,
              right: null,
              editing: false,
              draggable: true
            }
          );
          if (i == path.length - 1) {
            count += 1;
            return array // if all paths are done, then continue
          }
        } // end of inner for loop
      }
      
  }

  createNewFolderIdFromImagePath(folder){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/shared/Attachments/FolderToCase', {
     caseId: this.type.id,
     folderId: null,
     parentFolder: null,
     folderName: folder.name,
     fileAccessId: '4d32156a-20fe-4601-8cc8-0a4711034d6b'
   }, {headers});
  }

  updateImgFolderParentOnOldFiles(path,folderId){
    let files = this.files.filesWithoutFolder.filter(x => x.path == path);
    for(let x of files){
      this.attachFileToFolder(this.type.id,x.fileId,folderId, false);
      x['parentId'] = folderId;
    }
  }

  async deleteFoldersAndFiles(){
    let filesToDelete = this.deletionFiles.filter(x => !this.restrictedFiles.includes(x.fileId));
    let restrictedFilesToMoveToParent = this.deletionFiles.filter(x => this.restrictedFiles.includes(x.fileId));

    this.deletionFolders.forEach(x => { this.deleteFolder(x) });
    this.selection = filesToDelete.map(x => x.fileId);
    this.deleteFiles();
    await restrictedFilesToMoveToParent.forEach(x => {
      this.attachFileToFolder(this.type.id, x.fileId, this.root, false)
    })
    console.log(
      {
        folders: this.deletionFolders,
        files: this.deletionFiles,
        restricted: {
          filesToDelete : filesToDelete,
          filesToMove : restrictedFilesToMoveToParent,
          restrictedFiles: this.restrictedFiles
        }
      }
    )
    this.deletionFolders = [];
    this.deletionFiles = [];
    this.selection = [];
    this.treeFromFolders();
    this.filterImages();
  }

  deleteFolder(folderId){
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.put(api.jubloApi + 'api/shared/Attachments/DeleteFolder', { caseId: this.type.id,  folderId: folderId}, { headers }).subscribe(
      ()=>{  },
      ()=>{},
      ()=>{
        this.fileFolders = this.fileFolders.filter(x => x.id != folderId);
        this.treeFromFolders()
        console.log('folder deleted',folderId);
        console.log(this.fileFolders)
        
      }
    )
  }

  thumbDrag(e:DragEvent){
    e.dataTransfer.effectAllowed = "all"; 
    e.dataTransfer.dropEffect = "copy";
    let a = e.target as HTMLImageElement;
    a.dataset.test = a.src;
    e.dataTransfer.setData('text',a.src)
    e.dataTransfer.setDragImage(e.target as HTMLImageElement,0,0)
    console.log(e)
  }
}

interface ImageViewerType {
  type: 'case' | 'activity' | 'property' | 'package';
  id: string;
  externalId?:string;
}

export class ImageViewerOptions {
  showTree: boolean = false;
  hideTree: boolean = false;
  selectable: boolean = false;
  upload: boolean = true;
  autoOpen: boolean = false;
  hideOptions: boolean = false;
}

export class ImageViewerManipulators {
  rotate: number = 0;
}

interface ImageViewerUserInfo {
  id: string; // used in img links for rights purposes
  isAdmin: boolean;
  hasOS: boolean;
}
